module.exports = __webpack_public_path__ + "img/biaoqian_huochezhan.cc2b4a9f.png";